module.exports = __webpack_public_path__ + "img/ding-tan2.e294d90b.png";